import { attachSheetDismissGesture } from './sheetDismissGesture';

/** Directory-specific entry point retained for existing callers and tests. */
export function attachChapterDirectoryDismissGesture(sheet: HTMLElement, dismiss: () => void): void {
	attachSheetDismissGesture(sheet, dismiss, {
		chromeSelector: '.chapter-directory-header, .chapter-directory-hero',
		scrollSelector: '.chapter-directory-scroll',
		closeSelector: '.chapter-directory-close',
	});
}
